import { render, staticRenderFns } from "./ReturnQualityInspectionWorkbench.vue?vue&type=template&id=51c05659&scoped=true&"
import script from "./ReturnQualityInspectionWorkbench.vue?vue&type=script&lang=js&"
export * from "./ReturnQualityInspectionWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./ReturnQualityInspectionWorkbench.vue?vue&type=style&index=0&id=51c05659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c05659",
  null
  
)

export default component.exports